export const MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION_BG =
  "Perceptica анализира как организацията ви се възприема като работодател, сравнява ви с конкурентите и открива репутационни рискове и възможности за по-силно позициониране.";
